module.exports = __webpack_public_path__ + "media/images/sandbox/samus--thumb-766abc91fdea4d37599c2657b15c1bd8.png";